(function(){
    var inputs = document.querySelectorAll('input[type="tel"]');

    if (inputs.length && typeof window.intlTelInput === 'function') {
        initialize_intlTelInput(inputs);
    } else {
        var element = document.createElement("script");
        element.src = window.frontend_script_path+"/vendor/intlTelInput.min.js";
        element.onload = function() {
            initialize_intlTelInput(inputs);
        };
        document.body.appendChild(element);
    }
})();

function initialize_intlTelInput(inputs) {
    inputs.forEach(function(input){
        window.intlTelInput(input, {
            utilsScript: window.frontend_script_path+"/vendor/intlTelInput.utils.js",
            //autoInsertDialCode: true,
            autoPlaceholder: 'aggressive',
            nationalMode: false,
            separateDialCode: false,
            formatOnDisplay: true,
            initialCountry: input.getAttribute('data-country'),
            preferredCountries: []
        });
    });
}